import React from 'react';
import PropTypes from 'prop-types';

/**
 * Un componente de layout que apila elementos hijos vertical u horizontalmente.
 * Utiliza CSS Flexbox y permite una fácil personalización a través de props.
 */
const Stack = ({
  children,
  direction = 'column', // Por defecto, apila verticalmente
  gap = '16px',         // Espacio por defecto entre elementos
  justifyContent,
  alignItems,
  flexWrap,
  style,                // Para cualquier otra regla de estilo CSS
  className,            // Para clases CSS externas
  ...rest               // Para pasar cualquier otra prop de div (id, onClick, etc.)
}) => {

  // 1. Estilos base que definen el comportamiento Flexbox
  const stackStyles = {
    display: 'flex',
    flexDirection: direction,
    gap: gap,
    // Solo aplica estas propiedades si fueron definidas en las props
    justifyContent: justifyContent,
    alignItems: alignItems,
    flexWrap: flexWrap,
  };

  // 2. Combina los estilos base con los estilos personalizados pasados en la prop `style`
  // Los estilos en la prop `style` sobreescribirán los estilos base si hay conflicto.
  const combinedStyles = {
    ...stackStyles,
    ...style,
  };

  return (
    <div style={combinedStyles} className={className} {...rest}>
      {children}
    </div>
  );
};

// 3. (Opcional pero recomendado) Definir los tipos de las props para validación
Stack.propTypes = {
  /** El contenido que se renderizará dentro del Stack */
  children: PropTypes.node.isRequired,
  /** La dirección en que se apilan los elementos */
  direction: PropTypes.oneOf(['row', 'column', 'row-reverse', 'column-reverse']),
  /** El espacio entre los elementos hijos */
  gap: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Define la alineación en el eje principal (flex-direction) */
  justifyContent: PropTypes.string,
  /** Define la alineación en el eje transversal */
  alignItems: PropTypes.string,
  /** Define si los elementos deben saltar a la siguiente línea si no caben */
  flexWrap: PropTypes.oneOf(['nowrap', 'wrap', 'wrap-reverse']),
  /** Objeto para reglas de estilo CSS personalizadas */
  style: PropTypes.object,
  /** String para nombres de clases CSS adicionales */
  className: PropTypes.string,
};

export default Stack;